import { DELETE, GET, POST } from "@/utils/http";

const APPROVER_BASE_URI = "/license";

export const LicenseService = {
  create(formData: FormData): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(
      `${APPROVER_BASE_URI}/create`,
      formData,
      undefined,
      true,
    );
  },
  getDetail(
    licenseRegistrationId: number,
  ): Promise<LicenseRegistrationDetail | null | undefined> {
    return GET<LicenseRegistrationDetail>(
      `${APPROVER_BASE_URI}/detail/${licenseRegistrationId}`,
      undefined,
      true,
    );
  },
  delete(licenseId: number): Promise<SuccessResponse | null | undefined> {
    return DELETE<SuccessResponse>(`${APPROVER_BASE_URI}/delete/${licenseId}`);
  },
  search(
    request: SearchLicenseRequest,
  ): Promise<SearchLicenseResponse | null | undefined> {
    return POST<SearchLicenseResponse>(`${APPROVER_BASE_URI}/search`, request);
  },
};
